// Core
import { connect } from 'react-redux';
// Actions
import { setSelection, setInner, setExtra } from '../../../../ducks/noShop/Methods';

import Component from './Component';

const mapStateToProps = state => ({
    selection: state.noShop.q12.selection,
    inner: state.noShop.q12.inner,
    extra: state.noShop.q12.extra
});

const mapDispatchToProps = {
    setSelection,
    setInner,
    setExtra
};

const Q12 = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Q12;